import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  Renderer2,
  ViewChild
} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

const NTOGGLE_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NToggleComponent),
  multi: true
};

@Component({
  selector: "n-toggle",
  templateUrl: "./n-toggle.html",
  styleUrls: [
    "./n-toggle.css"
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    NTOGGLE_VALUE_ACCESSOR
  ]
})
export class NToggleComponent implements ControlValueAccessor {

  @Input() labelId: string;

  @ViewChild("checkbox", {read: ElementRef, static: true})
  checkbox: ElementRef;

  private propagateChange: (_) => void;
  private propagateTouch: () => void;

  constructor(private renderer: Renderer2, private cd: ChangeDetectorRef) {

  }

  @Input()
  set disabled(val: boolean) { // deprecated
    this.setDisabledState(val);
  }

  @Input()
  set isDisabled(val: boolean) {
    this.setDisabledState(val);
  }

  onChange(checked: boolean) {
    if (this.propagateChange) {
      this.propagateChange(checked);
    }

    if (this.propagateTouch) {
      this.propagateTouch();
    }
  }

  writeValue(val: boolean): void {
    this.renderer.setProperty(this.checkbox.nativeElement, "checked", val);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.checkbox.nativeElement, "disabled", isDisabled);
    this.cd.markForCheck();
  }

}
